import { FocusedImage } from 'image-focus';

import type { RefObject } from 'react';

/**
 * Adds focus to an image based on x and y coordinates
 * @param imageRef Image Ref
 * @param focalPointX x coordinate of the focal point
 * @param focalPointY y coordinate of the focal point
 * @returns an instance of a Focused Image with the image and coordinates attached
 */
function focusImage(
  imageRef: RefObject<HTMLImageElement | null>,
  focalPointX: number,
  focalPointY: number
): FocusedImage | undefined {
  let focusedImage;

  if (imageRef?.current) {
    focusedImage = new FocusedImage(imageRef.current, {
      focus: {
        x: focalPointX,
        y: focalPointY,
      },
      containerPosition: 'absolute',
    });
  }

  return focusedImage;
}

export default focusImage;
